module.exports = __webpack_public_path__ + "assets/img/25_341_big.934fe5e2.jpg";